import { CascaderOptionType } from "antd/es/cascader";

export const ACTION_RESULTS_LOADING_LABEL = "Loading Bag & Cache results...";

/**
 * Placeholder item inserted at the tail of Action Results while dynamic types
 * are still being fetched from the backend.
 *
 * Must be JSON-serializable: the bindables manifest walks the same cascader
 * tree and pipes it back to the LLM as a tool result. If the label is a React
 * element (the old implementation), JSON.stringify emits `$$typeof: Symbol(...)`
 * garbage. Keep it a plain string and let the cascader's own renderer show a
 * spinner based on `loading: true`.
 */
export const createActionResultsLoadingItem = (): CascaderOptionType => ({
  label: ACTION_RESULTS_LOADING_LABEL,
  loading: true,
  dynamicTypesOption: true
});
